/**
 * Utilitários para gerenciamento de token de autenticação do portal do cliente
 */

export const TOKEN_KEY = 'customer_token';

export interface JwtPayload {
  exp?: number;
  [key: string]: unknown;
}

/**
 * Decodifica o JWT sem verificar assinatura (apenas para ler payload)
 * Retorna o payload decodificado ou null se inválido
 */
export function decodeToken(token: string): JwtPayload | null {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Erro ao decodificar token:', error);
    return null;
  }
}

/**
 * Obtém o token do localStorage
 */
export function getToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * Verifica se o token está expirado
 * Retorna true se o token está expirado ou ausente, false caso contrário
 */
export function isTokenExpired(token?: string | null): boolean {
  const tokenToCheck = token !== undefined ? token : getToken();
  if (!tokenToCheck) return true;

  const decoded = decodeToken(tokenToCheck);
  if (!decoded || !decoded.exp) return true;

  // exp está em segundos, Date.now() está em milissegundos
  const expirationTime = decoded.exp * 1000;
  const now = Date.now();

  return now >= expirationTime;
}

/**
 * Verifica se o token está válido (existe e não está expirado)
 */
export function isTokenValid(): boolean {
  const token = getToken();
  if (!token) return false;
  return !isTokenExpired(token);
}
